// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
/* Store Custom Code - End */

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
            color: "secondary", // Store Custom Code
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
            `,
            /* Store Custom Code - Start */
            tooltipBody: css`
                background: ${getColor("common.accent")};
                box-shadow: ${x => x.theme.shadows.e40};
            `,
            tooltipArrow: css`
                border-color: ${getColor("common.accent")} transparent transparent transparent;
            `,
            /* Store Custom Code - End */
        },
        typographyProps: {
            weight: "normal",
            color: "secondary", // Store Custom Code
        },
    },
};

export default tooltip;
